/* DEMO (4 Nov): small scripts for Zac's change list. Each block is separate so it is easy to undo. */
(function () {
  'use strict';

  /* A. Homepage 'Brands Who Put Their Trust in us': the logos drift slowly sideways in an endless loop.
        Pauses when you hover or touch it. People who ask their device for reduced motion get the static logos. */
  function marquee() {
    var w = document.querySelector('.business-trust-logos-wrap');
    if (!w || w.querySelector('.dc-track')) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var kids = [].slice.call(w.children);
    if (!kids.length) return;
    var t = document.createElement('div');
    t.className = 'dc-track';
    kids.forEach(function (k) { t.appendChild(k); });
    w.appendChild(t);
    var sw = t.scrollWidth || 900;
    var k = Math.max(1, Math.ceil(2000 / sw));
    function copies(n) {
      for (var i = 0; i < n; i++) {
        kids.forEach(function (o) {
          var c = o.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          var im = c.querySelector('img');
          if (im) { im.alt = ''; im.setAttribute('loading', 'lazy'); }
          t.appendChild(c);
        });
      }
    }
    copies(2 * k - 1);
    t.style.animationDuration = Math.round((k * sw) / 45) + 's';
    w.classList.add('dc-marquee-on');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', marquee);
  else marquee();

  /* B. PHONES: Our Best Sellers row moves along by itself, one card every few seconds, then loops back to the start.
        Stops while a finger is on it (and for a while after), and for people who ask for reduced motion. */
  function bestSellers() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var tries = 0;
    (function find() {
      var ul = document.querySelector('#dc-popular .products-list');
      if (!ul || !ul.children.length) { if (++tries < 80) setTimeout(find, 250); return; }
      var hold = 0, visible = true;
      function stop() { hold = Date.now() + 7000; }
      ul.addEventListener('touchstart', stop, { passive: true });
      ul.addEventListener('touchmove', stop, { passive: true });
      ul.addEventListener('wheel', stop, { passive: true });
      if (window.IntersectionObserver) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(ul);
      setInterval(function () {
        if (document.hidden || !visible || Date.now() < hold) return;
        var max = ul.scrollWidth - ul.clientWidth;
        if (max <= 4) return;
        var step = ul.children[0].getBoundingClientRect().width + 10;
        if (ul.scrollLeft >= max - 4) ul.scrollTo({ left: 0, behavior: 'smooth' });
        else ul.scrollBy({ left: step, behavior: 'smooth' });
      }, 3200);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bestSellers);
  else bestSellers();

  /* C. Dispatch countdown wording, everywhere it appears (orange bar on computers AND phones, the bar's pop-up, and the 'Order within' line on product pages):
        once the hours reach 0 the hours are dropped (so '0h 42m 10s' reads '42m 10s'), and it is always written without leading zeros ('5m 9s'). The other scripts keep writing the clock every second; this tidies the words the moment they change, so nothing flickers. */
  function tidyClock(el) {
    var m = /^\s*(\d+)h\s+(\d+)m\s+(\d+)s\s*$/.exec(el.textContent);
    if (!m) return;
    var h = +m[1];
    var want = (h > 0 ? h + 'h ' : '') + (+m[2]) + 'm ' + (+m[3]) + 's';
    if (el.textContent !== want) el.textContent = want;
  }
  function clocks() {
    var seen = [];
    function scan() {
      Array.prototype.forEach.call(document.querySelectorAll('.dc-timer-clock, .dc-mclock, .dc-ship-n'), function (el) {
        if (seen.indexOf(el) > -1) return;
        seen.push(el);
        tidyClock(el);
        if (window.MutationObserver) new MutationObserver(function () { tidyClock(el); }).observe(el, { childList: true, characterData: true, subtree: true });
      });
    }
    scan();
    var n = 0, iv = setInterval(function () { scan(); if (++n > 60) clearInterval(iv); }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clocks);
  else clocks();
})();

/* E. (4 Nov pm) COLLECTION PAGES AND THE SEARCH RESULTS PAGE: a PRICE slider in the 'Refine by' box, under Type / Weight / Region.
      It uses Shopify's own price filter in the address (?filter.v.price.gte=10&filter.v.price.lte=30), so it filters the WHOLE collection (every page), the Type / Weight / Region choices are kept, and the page is an ordinary page (nothing is hidden by script). Nothing changes for Google: it never moves a slider.
      The slider runs from the CHEAPEST to the DEAREST product in this collection (read from the collection itself, to the penny at the two ends). It is not even in steps of the same size: most of its length covers the cheap end so those products are easy to pick, and the far end reaches the dearest. Undo = delete this block and block 14 in dc-nov4.css.
      (4 Nov eve: on the search page the cheapest / dearest are read from the same search (the words typed and any other filters are kept, only the price filter is left out).) */
(function () {
  function init() {
    var list = document.querySelector('#collection-filter-by .collection-filters-list');
    if (!list || document.getElementById('dc-price')) return;
    var qs = new URLSearchParams(location.search);
    var gLo = parseFloat(qs.get('filter.v.price.gte')), gHi = parseFloat(qs.get('filter.v.price.lte'));
    function num(m) { return parseFloat(String(m.textContent).replace(/[^0-9.]/g, '')); }
    /* a first guess from the products on this page; the real cheapest / dearest come from the collection a moment later */
    var MIN = Infinity, MAX = 0;
    [].forEach.call(document.querySelectorAll('#product-listings ul.products-list > li.product .price-variation .money'), function (m) {
      var n = num(m);
      if (n > 0 && n < MIN) MIN = n;
      if (n > MAX) MAX = n;
    });
    MIN = isFinite(MIN) ? MIN : 0;
    MAX = Math.max(MAX, gHi || 0, gLo || 0, MIN + 0.01);

    var li = document.createElement('li');
    li.id = 'dc-price';
    li.className = 'collection-filter dc-price';
    li.innerHTML = '<label for="dc-pr-lo">Price</label>' +
      '<div class="dc-pr-val" aria-live="polite"></div>' +
      '<div class="dc-pr-rail"><div class="dc-pr-fill"></div>' +
      '<input id="dc-pr-lo" type="range" min="0" max="100" step="1" value="0" aria-label="Lowest price" disabled>' +
      '<input id="dc-pr-hi" type="range" min="0" max="100" step="1" value="100" aria-label="Highest price" disabled></div>' +
      '<a class="dc-pr-clear" href="#" hidden>Clear price</a>';
    list.appendChild(li);
    var lo = li.querySelector('#dc-pr-lo'), hi = li.querySelector('#dc-pr-hi'), fill = li.querySelector('.dc-pr-fill'), val = li.querySelector('.dc-pr-val'), clr = li.querySelector('.dc-pr-clear');

    /* position (0-100) <-> price between MIN and MAX (both exact, to the penny). Cubed, so the first part of the slider moves slowly through the cheap products and the far end speeds up to the dearest. */
    function toPrice(v) {
      v = +v;
      if (v <= 0) return MIN;
      if (v >= 100) return MAX;
      var p = MIN + (MAX - MIN) * Math.pow(v / 100, 3);
      var s = p < 20 ? 1 : p < 100 ? 5 : p < 1000 ? 10 : 50;
      return Math.max(MIN, Math.min(MAX, Math.round(p / s) * s));
    }
    function toPos(p) {
      if (MAX <= MIN) return 0;
      return Math.max(0, Math.min(100, Math.round(100 * Math.cbrt(Math.max(0, p - MIN) / (MAX - MIN)))));
    }
    function money(n) {
      n = Math.round(n * 100) / 100;
      return '£' + n.toLocaleString('en-GB', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
    }
    /* The exact figures from the address stay exact until that handle is moved, so a filter of GBP 50 reads 'GBP 50' and not the nearest slider notch. */
    var exLo = isNaN(gLo) ? null : gLo, exHi = isNaN(gHi) ? null : gHi;
    function priceLo() { return (exLo != null && +lo.value === toPos(exLo)) ? exLo : toPrice(lo.value); }
    function priceHi() { return (exHi != null && +hi.value === toPos(exHi)) ? exHi : toPrice(hi.value); }
    function paint() {
      var a = +lo.value, b = +hi.value;
      fill.style.left = a + '%';
      fill.style.width = (b - a) + '%';
      val.textContent = money(priceLo()) + ' – ' + money(priceHi());
      clr.hidden = !(a > 0 || b < 100);
    }
    function setFromUrl() {
      lo.value = exLo == null ? 0 : toPos(exLo);
      hi.value = exHi == null ? 100 : toPos(exHi);
      paint();
    }
    function go() {
      var q = new URLSearchParams(location.search);
      q.delete('page'); q.delete('filter.v.price.gte'); q.delete('filter.v.price.lte');
      var a = +lo.value, b = +hi.value;
      if (a > 0) q.set('filter.v.price.gte', priceLo());
      if (b < 100) q.set('filter.v.price.lte', priceHi());
      var s = q.toString();
      location.assign(location.pathname + (s ? '?' + s : ''));
    }
    var t;
    function onInput(e) {
      if (+lo.value > +hi.value) { if (e.target === lo) lo.value = hi.value; else hi.value = lo.value; }
      paint();
    }
    function onChange() { clearTimeout(t); t = setTimeout(go, 450); }
    lo.addEventListener('input', onInput); hi.addEventListener('input', onInput);
    lo.addEventListener('change', onChange); hi.addEventListener('change', onChange);
    clr.addEventListener('click', function (e) {
      e.preventDefault(); exLo = exHi = null; lo.value = 0; hi.value = 100; paint(); go();
    });
    setFromUrl();

    /* Learn the cheapest and dearest price in this whole collection / search (not just this page). Two small requests, only on collection and search pages; the slider switches on when they are back (or after 4 seconds, using this page's prices). */
    function enable() { lo.disabled = false; hi.disabled = false; li.classList.add('dc-pr-ready'); }
    var done = false;
    function finish(min, max) {
      if (done) return; done = true;
      if (max > 0 && max >= min) {
        MIN = min;
        MAX = Math.max(max, gHi || 0, gLo || 0, MIN + 0.01);
        setFromUrl();
      }
      enable();
    }
    function firstPrice(order) {
      var q = new URLSearchParams(location.search);
      q.delete('page'); q.delete('filter.v.price.gte'); q.delete('filter.v.price.lte');
      q.set('sort_by', order);
      return fetch(location.pathname + '?' + q.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (h) {
          var d = new DOMParser().parseFromString(h || '', 'text/html');
          var m = d.querySelector('#product-listings ul.products-list > li.product .price-variation .money');
          return m ? num(m) : 0;
        });
    }
    try {
      Promise.all([firstPrice('price-ascending'), firstPrice('price-descending')])
        .then(function (r) { finish(r[0], r[1]); })
        .catch(function () { finish(0, 0); });
      setTimeout(function () { finish(0, 0); }, 4000);
    } catch (e) { finish(0, 0); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* D. (4 Nov) Loads our own basket drawer (assets/dc-drawer.css + dc-drawer.js). Undo = delete this block.
      DRAWER_V: Shopify keeps a file at its plain address for a year, so this number is on the end of the address. Change it every time dc-drawer.css or dc-drawer.js is edited, and everyone gets the new version straight away. */
(function () {
  var DRAWER_V = '20261104k';
  var base = (document.currentScript && document.currentScript.src) ? document.currentScript.src.replace(/dc-nov4\.js.*$/, '') : '';
  if (!base) { var s0 = document.querySelector('script[src*="dc-nov4.js"]'); if (s0) base = s0.src.replace(/dc-nov4\.js.*$/, ''); }
  if (!base) return;
  var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = base + 'dc-drawer.css?v=' + DRAWER_V; document.head.appendChild(l);
  var s = document.createElement('script'); s.src = base + 'dc-drawer.js?v=' + DRAWER_V; s.async = false; document.head.appendChild(s);
})();

/* F. (4 Nov eve) Loads our own live search box (assets/dc-search.js) and its extras (assets/dc-search-extra.js: Buy Now in the drop-down, results page search box, Brand / Size / Single-or-case choices). Undo = delete this block.
      SEARCH_V: FIXED for go-live (5 Nov). Shopify keeps a file at its plain address for a year, so this number is on the end of the address. Change it every time dc-search.js or dc-search-extra.js is edited (same idea as DRAWER_V above), then everyone gets the new version straight away. */
(function () {
  var SEARCH_V = '20261105a';
  var base = (document.currentScript && document.currentScript.src) ? document.currentScript.src.replace(/dc-nov4\.js.*$/, '') : '';
  if (!base) { var s0 = document.querySelector('script[src*="dc-nov4.js"]'); if (s0) base = s0.src.replace(/dc-nov4\.js.*$/, ''); }
  if (!base) return;
  var s = document.createElement('script'); s.src = base + 'dc-search.js?v=' + SEARCH_V; s.async = false; document.head.appendChild(s);
  var x = document.createElement('script'); x.src = base + 'dc-search-extra.js?v=' + SEARCH_V; x.async = false; document.head.appendChild(x);
})();
